var dateFormat = require("dateformat");
dateFormat.i18n = {
    dayNames: [
        "Dom",
        "Seg",
        "Ter",
        "Qua",
        "Qui",
        "Sex",
        "Sáb",
        "Domingo",
        "Segunda",
        "Terça",
        "Quarta",
        "Quinta",
        "Sexta",
        "Sábado",
    ],
    monthNames: [
        "Jan",
        "Fev",
        "Mar",
        "Abr",
        "Mai",
        "Jun",
        "Jul",
        "Ago",
        "Set",
        "Out",
        "Nov",
        "Dez",
        "Janeiro",
        "Fevereiro",
        "Março",
        "Abril",
        "Maio",
        "Junho",
        "Julho",
        "Agosto",
        "Setembro",
        "Outubro",
        "Novembro",
        "Dezembro",
    ],
    timeNames: ["a", "p", "am", "pm", "A", "P", "AM", "PM"],
};

const toDateIfPossible = (value) => {
    if (value instanceof Date) return value;
    if (typeof value === "number") return new Date(value);
    if (typeof value === "string") return new Date(value);
    return value;
};

const isValidDate = (d) => d instanceof Date && !Number.isNaN(d.getTime());

const instance = (date, maskOrShort) => {
    if (!date) return "--";

    const parsed = toDateIfPossible(date);
    const asDate = parsed instanceof Date ? parsed : new Date(parsed);
    if (!isValidDate(asDate)) return "--";

    // Compat: 2º parâmetro booleano (short) mantém comportamento antigo
    if (typeof maskOrShort === "boolean") {
        return maskOrShort
            ? dateFormat(asDate, "dd/mm/yyyy h:MM TT")
            : dateFormat(asDate, "dddd, d, mmmm, yyyy, h:MM:ss TT");
    }

    // Novo: permite passar máscara diretamente (ex.: "UTC:dd/mm/yy HH:MM")
    if (typeof maskOrShort === "string" && maskOrShort.trim() !== "") {
        return dateFormat(asDate, maskOrShort);
    }

    return dateFormat(asDate, "dddd, d, mmmm, yyyy, h:MM:ss TT");
};

export default instance;